import React, {useState} from "react";
import {ShowHideForm} from "../../../shared/ui/forms/ShowHideForm";
import {FormCreateLpSub} from "./FormCreateLpSub";
import {configCloseForm} from "../../../shared/ui/forms/dataForm";
import { useLanguageForShared } from "../../../../shared/utils/languages/useLanguageForShared";


export function CreateLpSub() {
  const {t} = useLanguageForShared()
  const [config, setConfig]= useState();
  return (
      <ShowHideForm config={config} buttonLabel={t('sgbo.addPricesCatalog')}>
        <FormCreateLpSub closeForm={() => setConfig(configCloseForm())} />
      </ShowHideForm>
  );
}
